import { createSlice } from "@reduxjs/toolkit";

export interface ClearRefinementSliceState {
  refinementToRemove: string | null;
}

const initialState = {
  refinementToRemove: undefined,
};

export const clearRefinementSlice = createSlice({
  name: "clearRefinementSlice",
  initialState,
  reducers: {
    setRefinementToClear: (state, action) => {
      state.refinementToRemove = action.payload;
    },
    setComplete: (state) => {
      state.refinementToRemove = undefined;
    },
  },
});

export const { setRefinementToClear, setComplete } = clearRefinementSlice.actions;
export default clearRefinementSlice;
